import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
      <div class="poem">
        <p class="poem-block mb-3">
          Все надежды разбиваются – вдрызг,<br/>
          И с веселым звоном – в мусорное ведро.<br/>
          Мне в этом году – все удары – в дых,<br/>
          И ни в чем ни разу не повезло.
        </p>

        <p class="poem-block mb-3">
          Мне в этом году все дороги – вспять,<br/>
          На всех насыпано битое стекло.<br/>
          Все, казалось бы, можно взять,<br/>
          Но ни в чем ни разу не повезло.
        </p>

        <p class="poem-block mb-3">
          Все надежды, как поганый рой,<br/>
          Вьются, обещая: Вот, ОНО пришло!<br/>
          Но сколько ни кидалась я на зов пустой,<br/>
          Мне ни в чем ни разу не повезло.
        </p>

        <p class="poem-block mb-3">
          Мягко стелет, да жестко спать.<br/>
          Смеется отвратительное мурло.<br/>
          Как хорошо заранее знать,<br/>
          Что мне и сегодня не повезло.
        </p>

        <p class="poem-block mb-3">
          Бессильна я пред тобой, судьба,<br/>
          Но, хоть ты все делаешь мне назло,<br/>
          Ты не сотворишь из меня раба:<br/>
          Мне только сегодня не повезло!
        </p>
      </div>
    `
  )
}

const itemName = {
  rus: 'Все надежды разбиваются'
}
const itemDate = {
  rus: '2 сентября 2002'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;